const ActionTypes = ["LAYOUT_WINDOW_TOGGLED"]

export default ActionTypes
